import options from './thing-description.component';

export default {
    selector: 'dtThingDescription',
    options
};
